import { useLocation } from 'react-router-dom'
import { InstallationTab } from '../types'

/**
 * Hook to return the correct tab index for the installer dashboard page, taking into account the url called
 * @param prevTabValue - the value saved as previously called tab, if the user returns to this page
 * @returns Id of the current tab
 */
export const useCurrentTabIdFromUrl = (prevTabValue: number, tabs: InstallationTab[] | undefined): number => {
  const location = useLocation()

  const tabIndex = tabs?.findIndex(tab => tab.url === location.pathname)

  if (tabIndex !== undefined && tabIndex !== -1) return tabIndex

  if (tabs && (prevTabValue < 0 || prevTabValue >= tabs.length)) return 0

  return prevTabValue
}
